import Vue from "vue";
import VueRouter from "vue-router";
import CatalogoWeb from "@/components/Catalogo/CatalogoWeb.vue";
import ProductoDetalle from "@/components/Catalogo/ProductoDetalle.vue";
import NosotrosMaxica from "@/components/Catalogo/NosotrosMaxica.vue";
import PoliticasMaxica from "@/components/Catalogo/PoliticasMaxica.vue";
import InicioSesion from "@/components/Usuarios/InicioSesion.vue";
import FinalizarCompra from "@/components/Catalogo/FinalizarCompra.vue";
import RegistroWeb from "@/components/Catalogo/RegistroWeb.vue";
import MiPerfil from "@/components/Usuarios/MiPerfil.vue";
import MaxiPuntos from "@/components/MaxiPuntos/MaxiPuntos.vue";
import DescargarCatalogo from "@/components/Catalogo/DescargarCatalogo.vue";
import LinksMaxica from "@/components/Catalogo/LinksMaxica.vue";
import HomeMaxica from "@/views/HomeMaxica.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/tienda",
    name: "CatalogoWeb",
    component: CatalogoWeb,
  },
  {
    path: "/categoria/:slug",
    name: "CatalogoCategoria",
    component: CatalogoWeb,
  },
  {
    path: "/",
    name: "HomeMaxica",
    component: HomeMaxica,
  },
  {
   path:"/registro-web",
   name: "RegistroWeb",
    component: RegistroWeb,
  },
  {
    path: "/nosotros",
    name: "NosotrosMaxica",
    component: NosotrosMaxica,
  },
  {
    path: "/politicas",
    name: "PoliticasMaxica",
    component: PoliticasMaxica,
  },
  {
    path: "/producto/:id/:slug?",
    name: "ProductoDetalle",
    component: ProductoDetalle,
    props: true, // si quieres que el id venga como prop
  },
   {
    path: "/login",
    name: "InicioSesion",
    component: InicioSesion,
    props: true, // si quieres que el id venga como prop
  },
  {
    path: "/finalizar-compra",
    name: "FinalizarCompra",
    component: FinalizarCompra,
    props: true, // si quieres que el id venga como prop
  },
  {
    path: "/perfil",
    name: "MiPerfil",
    component: MiPerfil,
  },
  {
    path: "/maxi-puntos",
    name: "MaxiPuntos",
    component: MaxiPuntos,
  },
  {
    path: "/descargar-catalogo",
    name: "DescargarCatalogo",
    component: DescargarCatalogo,
  },
  {
    path: "/links",
    name: "LinksMaxica",
    component: LinksMaxica,
  },
];

export default new VueRouter({
  mode: "hash",
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.name === "ProductoDetalle") return { x: 0, y: 0 };
    if (savedPosition) return savedPosition;
    return { x: 0, y: 0 };
  },
});
